import React from "react";
import { Container, Button } from "rsuite";
import { useTranslation } from "react-i18next";
import PermissionDeniedImage from "../../../icons/401-bg.jpg";
import { useNavigate } from "react-router-dom";
import { ContentRoutes } from "../../../navigation/NavConstant";

export function Page401() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(ContentRoutes.DASHBOARD);
  };

  return (
    <div className="users error-pg">
      <Container className="container">
        <div className="row mb-2" style={{height: "calc(100vh - 26vh)", display: "flex", alignItems: "center"}}>
          <div className="col-md-3 offset-3">
            <img src={PermissionDeniedImage} alt="401 Permission Denied" />
          </div>
          <div className="col-md-4">
            <h1 className="mb-0">401</h1>
            <h3 className="txt-rd">Permission Denied</h3>
            <h4 className="mb-3 mt-1">Opps! Something went wrong.</h4>
            <p>You do not have right permission to view this page</p>
            <div className="mt-3">
              <Button
                className="rs-btn"
                appearance="primary"
                onClick={handleRedirect}
              >
                {t("Home")}
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
